import { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { useQueryParams } from '../../core/hooks'

import { PAGINATION } from '../../common/constants'
import { apolloService } from '../../common/services'

import { useLoggedInUser } from '../../account/hooks'
import { DELETE_PRIORITY_TASK_ALLOCATION_MUTATION } from '../graphql/mutations'
import {
  PRIORITY_TASK_MENU_ALLOCATION_COUNTS_QUERY,
  PRIORITY_TASK_MENU_CURATION_TASKS,
  USER_ALLOCATION_COUNTS_QUERY,
} from '../graphql/queries'
import {
  DELETE_PRIORITY_TASK_ALLOCATION,
  FETCH_PRIORITY_TASK_MENU_ALLOCATION_COUNTS,
  FETCH_PRIORITY_TASK_MENU_CURATION_TASKS,
  FETCH_USER_ALLOCATION_COUNTS,
} from '../redux/action-types'

const useDeletePriorityTaskAllocationMutation = () => {
  const { id } = useParams()
  const { settings: userSettings } = useLoggedInUser()
  const dispatch = useDispatch()

  const {
    deletePriorityTaskAllocationError: error,
    isDeletePriorityTaskAllocationLoading: isLoading,
  } = useSelector(store => store.priorityTasks.priorityTask)

  const {
    allocatedUserId = null,
    allocationStatus = null,
    currentPage = PAGINATION.DEFAULT_PAGE,
    pageSize = userSettings?.pageSize || PAGINATION.DEFAULT_PAGE_SIZE,
  } = useQueryParams()

  const { filters, pagination } = useMemo(
    () => ({
      filters: {
        priorityTaskId: id,
        allocatedUserId,
        allocationStatus,
      },
      pagination: {
        pageSize,
        currentPage,
      },
    }),
    [id, allocatedUserId, allocationStatus, pageSize, currentPage],
  )

  const onSuccess = useCallback(() => {
    apolloService.query({
      query: USER_ALLOCATION_COUNTS_QUERY,
      variables: {
        id,
      },
      dispatch,
      action: FETCH_USER_ALLOCATION_COUNTS,
    })
    apolloService.query({
      query: PRIORITY_TASK_MENU_ALLOCATION_COUNTS_QUERY,
      variables: {
        priorityTaskId: id,
      },
      dispatch,
      action: FETCH_PRIORITY_TASK_MENU_ALLOCATION_COUNTS,
    })
    apolloService.query({
      query: PRIORITY_TASK_MENU_CURATION_TASKS,
      variables: {
        filters,
        pagination,
      },
      dispatch,
      action: FETCH_PRIORITY_TASK_MENU_CURATION_TASKS,
    })
  }, [dispatch, id, filters, pagination])

  const mutate = useCallback(
    ids =>
      apolloService.mutate({
        mutation: DELETE_PRIORITY_TASK_ALLOCATION_MUTATION,
        variables: { ids },
        dispatch,
        action: DELETE_PRIORITY_TASK_ALLOCATION,
        onSuccess,
      }),
    [dispatch, onSuccess],
  )

  return [mutate, { error, isLoading }]
}

export default useDeletePriorityTaskAllocationMutation
